export class YarnTypeTextileDataCardItem {
  private readonly _id: number;
  private readonly _name: string;

  public constructor(id: number, name: string) {
    this._id = id;
    this._name = name;
  }

  public get id(): number {
    return this._id;
  }

  public get name(): string {
    return this._name;
  }

  public static getRandomYarnType(): YarnTypeTextileDataCardItem {
    return this.getRandomYarnTypeWithIdAndName(1, 'YarnTypeTextileDataCardItem');
  }

  public static getRandomYarnTypeWithIdAndName(id: number, name: string): YarnTypeTextileDataCardItem {
    return new YarnTypeTextileDataCardItem(id, name);
  }
}
